import { Box, Stack, styled, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import Image from '../../components/Image';
import useLocales from '../../hooks/useLocales';
import { useSelector } from '../../redux/store';
import { HEADER, NAVBAR } from '../../config';
import Scrollbar from '../../components/Scrollbar';
import useAuth from '../../hooks/useAuth';

const NavButtonWrapper = styled(Box)(({ theme, isActive }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '2px',
  background: 'linear-gradient(174.34deg, #FEFFFF 4.51%, #6BA4FF 140.5%)',
  border: '1px solid #007FFF',
  borderRadius: '8px',
  color: '#000',
  padding: '2px 0px',
  cursor: 'pointer',
  ...(isActive && {
    background: 'linear-gradient(273.4deg, rgba(58, 0, 152, 0) 12.81%, #0028C9 96.52%)',
    boxShadow: '0px 0px 6.5px 0px #0166CD',
    border: '2px solid #FFFFFF',
    color: '#fff',
  }),
}));

const NavButtonTitle = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    fontSize: '14px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '13px',
  },
}));

const NavButtons = [
  {
    title: 'home',
    icon: require('../../assets/home/nav-home.webp'),
    value: 'home',
  },
  {
    title: 'casino',
    icon: require('../../assets/home/nav-casino.webp'),
    value: 'live-casino',
  },
  {
    title: 'slots',
    icon: require('../../assets/home/nav-slots.webp'),
    value: 'slots',
  },
  {
    title: 'fish',
    icon: require('../../assets/home/nav-fish.webp'),
    value: 'fishing',
  },
  {
    title: 'sports',
    icon: require('../../assets/home/nav-sports.webp'),
    value: 'sports',
  },
  {
    title: 'e-sports',
    icon: require('../../assets/home/nav-esport.png'),
    value: 'e-sports',
  },
  {
    title: 'instant-game',
    icon: require('../../assets/home/nav-instant.webp'),
    value: 'instant-game',
  },
  {
    title: 'card',
    icon: require('../../assets/home/nav-cards.webp'),
    value: 'card-game',
  },
  {
    title: 'lottery',
    icon: require('../../assets/home/nav-lottery.png'),
    value: 'lottery',
  },
];

const HomeNavCol = () => {
  const { translate } = useLocales();

  const { isAuthenticated } = useAuth();

  const { gameCategsAndCompanies } = useSelector((x) => x.lookup);

  const filteredBtns = useMemo(() => {
    const newBtns = [NavButtons[0]];

    gameCategsAndCompanies.forEach((x) => {
      const found = NavButtons.find((b) => b.value === x.slug);
      if (found) newBtns.push({ ...found, title: x.name });
      else newBtns.push({ ...found, title: x.name, icon: require('../../assets/home/nav-esport.png') });
    });

    return newBtns;
  }, [gameCategsAndCompanies]);

  const navigate = useNavigate();

  const location = useLocation();

  const params = useParams();

  const maxHeight = useMemo(() => {
    let diff = HEADER.MOBILE_HEIGHT + 10;
    if (isAuthenticated) diff = HEADER.MOBILE_HEIGHT + NAVBAR.MOBILE_BOTTOM_HEIGHT + 10;
    return `calc(100vh - ${diff}px)`;
  }, [isAuthenticated]);

  return (
    <Scrollbar
      rootSx={{
        position: 'sticky',
        top: `${HEADER.MOBILE_HEIGHT + 5}px`,
        maxHeight,
      }}
    >
      <Stack spacing={1}>
        {filteredBtns.map((x, idx) => (
          <NavButtonWrapper
            key={idx}
            isActive={
              ((location.state?.categ === x.value || (!location.state?.categ && x.value === 'home')) &&
                location.pathname === '/home') ||
              params?.categSlug === x.value
            }
            onClick={() => navigate('home', { state: { categ: x.value } })}
          >
            <Box
              sx={{
                width: { md: '80%', sm: '80%', xs: '60%' },
                minHeight: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Image src={x.icon} sx={{ width: '100%' }} />
            </Box>
            <NavButtonTitle>{x.title === 'home' ? translate(x.title) : x.title}</NavButtonTitle>
          </NavButtonWrapper>
        ))}
      </Stack>
    </Scrollbar>
  );
};

export default HomeNavCol;
